import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import type {
  PreAllocationCard,
  PreAllocationColumn
} from '@/types/qualification-eligibility.types'

/**
 * Kanban "Demandas urgentes" (D38/D43): a coluna é derivada pelo backend; mover só valida.
 * `move` responde 204, ou 422 `PRE_ALLOCATION_HAS_PENDING_ITEMS` com `missing`.
 */
export default class PreAllocationsService extends Service {
  constructor() {
    super()
    this.prefix = '/pre-allocations'
  }

  async list(): Promise<PreAllocationCard[]> {
    try {
      const { data } = await request.get<PreAllocationCard[]>(this.getCompletePath())
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as demandas urgentes')
    }
  }

  async move(id: number, column: PreAllocationColumn): Promise<void> {
    try {
      await request.post(this.getCompletePath(`/${id}/move`), { column })
    } catch (e) {
      throw this.handleError(e, 'Não foi possível mover a demanda')
    }
  }
}
